export default __webpack_public_path__ + "static/media/404.a5ba6d69.jpg";